import React, { useState, useEffect } from 'react';
import ImageGrid from './ImageGrid';
import { FaRegHeart } from 'react-icons/fa';
import PageHero from './PageHero';
import { cacheStrategy } from '../utils/cacheStrategy';
import { getPrivateCacheScope } from '../utils/privateCacheScope.js';
import { useAuth } from '../contexts/AuthContext';

export default function Favorites() {
  const { user } = useAuth();
  const userId = getPrivateCacheScope().scope;
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);

  async function loadFavorites(forceRefresh = false) {
    if (!forceRefresh && user && userId) {
      const cached = await cacheStrategy.get('favorites', { userId });
      if (cached) {
        const cachedImages = cached.data?.images || cached.data;
        if (Array.isArray(cachedImages)) {
          setFavorites(cachedImages);
          setLoading(false);
          if (cached.fresh) return;
        }
      }
    }

    setLoading(true);
    try {
      const response = await fetch('/api/images?is_favorite=true&limit=1000&fields=compact&variants=xl,lg', { 
        credentials: 'include' 
      });
      const data = await response.json();
      // Handle both old and new API response formats
      const images = data.images || data;
      const nextFavorites = Array.isArray(images) ? images : [];
      setFavorites(nextFavorites);
      if (user && userId) cacheStrategy.set('favorites', nextFavorites, { userId });
    } catch (error) {
      console.error('Failed to load favorites:', error);
      setFavorites([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadFavorites();
  }, [user?.id]);

  if (loading) {
    return (
      <>
        <PageHero
          eyebrow="Library"
          title="Favorites"
          />
        <section className="page-surface page-surface--padded">
        </section>
      </>
    );
  }

  return (
    <>
      <PageHero
        eyebrow="Library"
        title="Favorites"
        stats={[{ label: 'Photos', value: favorites.length }]}
      />
      <section className="page-surface page-surface--padded">
      {favorites.length > 0 ? (
        <ImageGrid images={favorites} onRefresh={loadFavorites} />
      ) : (
        <div className="empty-state">
          <div className="empty-icon">
            <FaRegHeart size={48} style={{ color: 'var(--text-muted)' }} />
          </div>
          <h3>No favorites yet</h3>
          <p>Like photos to see them appear here automatically</p>
        </div>
      )}
      </section>
    </>
  );
}
